import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialIssuesStatusesState = "";

const extraIssueSlice = createSlice({
  name: "extraIssue",
  initialState: initialIssuesStatusesState,
  reducers: {
    setExtraIssuesData: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setExtraIssuesData } = extraIssueSlice.actions;

export const extraIssue = extraIssueSlice.reducer;

export default extraIssueSlice.reducer;
